import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=0f79fc87"
import script from "./NewCustomer.vue?vue&type=script&lang=js"
export * from "./NewCustomer.vue?vue&type=script&lang=js"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=0f79fc87&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f79fc87')) {
      api.createRecord('0f79fc87', component.options)
    } else {
      api.reload('0f79fc87', component.options)
    }
    module.hot.accept("./NewCustomer.vue?vue&type=template&id=0f79fc87", function () {
      api.rerender('0f79fc87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/performanceReport/components/NewCustomer.vue"
export default component.exports